import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../../components/feature/Header';
import Footer from '../../../../components/feature/Footer';

const OnishiPage = () => {
  // ページ読み込み時のスクロール処理を削除
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const testimonial = {
    name: '尾西様',
    title: '代表',
    company: '横浜あおば戦略研究所',
    image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/01b737107832c8916c5b9b65ecaa5c33.png',
    sections: [
      {
        question: '私に相談する前はどんなことで悩んでましたか?',
        answer: '僕は起業してですね、期せずして起業したもんだから何も準備をしていなかったんですね。そのとき、コーチングビジネスが流行ってるだのソーシャルメディアで集客するだのみたいなのを目にして耳にして、じゃあ自分も見よう見まねでやってみようということで、コーチングビジネスを始めて、ソーシャルメディアで集客をするという、素人事業を始めたわけなんですよ。そこからスタートしてですね、そもそもソーシャルメディアで集客をするとかアクセスを集める、コミュニケーションとか興味を持ってもらう技術が長けてきたせいか、もともとの売りたいコーチングは売れないんですけど、どうやってそうやってフェイスブックで人気取れるんですかとか、フェイスブックでイベントしたら、どうしてそんなに人集めることが出来るんですかということで、フェイスブックのブランディングとか集客とかアクセスアップのコンサルタントっていう地位が築けたんですね。それで、仕事、マーケティングコンサルタントみたいな形で進めてきたもののですね、やっぱりそのジャンルって他にも競合とか重鎮とか老舗の人とか有名な人とか本書いてる先生とかそういう人たちとバッティングする、そして供給者がたくさんいるジャンルだっていう、なんていうんですかね、マーケティングとか経営戦略とかそういうところまで全然勉強してなかったものでですね、もうフェイスブックの時流の波にちょろっと乗れた程度で、その後全然フェイスブックコンサルタントとかそういうマーケティングコンサルタントとしての仕事とかもなかなか取れないと、要はなになに先生とあなた何が違うのとか、どこどこのコンサルタント会社とあなた何が違う、あっちのほうが有名だよねとかいうので全然仕事が取れなくなってきたと。それで仕事取るためにセールストークを磨いたりとかマーケティングセンスを磨いたりとかコピーライティング、チラシとかセールスレターのコピーをさらに技を高めるみたいなことをやってたんですけど、でもやっぱりなんか苦労の割にはなかなか契約が決まらないとかすぐ契約が終わっちゃうとか実入りが少ないとか、なんかこのままじゃいけないなと。結局それは原点に、戦略的なところから見ると供給過多なところにいるよとか、自分が不利なポジションにいるということに気付いて、じゃあ有利なポジションを取りたいなというふうに考えたわけですね。で、そのときにポジショニング戦略とかランチェスター戦略とかを勉強するようになったんですが、なんかこう、物理的にはポジショニング出来てるのにいまいち効果が上がらないと。これはひょっとして仕切るノウハウどうこうじゃなくて、結局経営理念とか何の為に働くとか人の為に働こうっていう意志があるのかどうかとかもっと根源的なものなんじゃないかなというところに気付き始めて、日本の古来の精神とか武士道だとか経営理念とか、そういう精神の部分とか、マインドと言われるところですか、そういうとこを勉強してるときにちょうど知恵蔵先生も色々見識が広い方なので、いや自分最近こういうことやってると、色々戦略とか知識とかノウハウ使ってポジショニングとかそういうのやってきたがなんか上手く行かないと。そこでなんかフェイスブックの投稿とか見てても知恵蔵先生の言ってらっしゃることも結構理念とかマインドとか志みたいなものを感じたんで、知恵蔵先生だったらなんか知ってるかもしれないなと思って、ちょっと最近こんなんなんですけどどうですかみたいな感じで相談に乗ってもらおうかなというのがきっかけでありました。'
      },
      {
        question: 'いつどんなきっかけで私に興味を持たれましたか?',
        answer: 'そうですね、もともと遠藤先生のところで、勉強会でお会いしたのが始めてだったんですけど、そこで発言されてるときにものすごくアイデアの切り口が良いっていうことと、アイデアがすごいたくさん出てくる方だったんで、この方すごい賢い方だなというところがすごく印象的だったんですね。そんなときに自分の事業が行き詰まってきて、なんとか誰か自分以外の方の知恵をお借りしたいと。そんなときに経営理念のこととか戦略のこととかそういうことがフェイスブックで投稿されてるのを拝見してですね、あ、これひょっとしたら赤石先生だったら詳しいことをご存知でいらっしゃるのかなと。あとはせいわ塾にも入ってらっしゃるんじゃないかなと思って、そのへんのこともちょっとお聞きしようかなという質問もかねて、まずは気軽な感じで知恵蔵先生、最近こういうこと考えてるんですけど、投稿とか見たらやっぱりすごいやり方っていう気がするんですよねと。どうなんですかっていうところで、そっちの方面の知識とか経験とかにも長けてらっしゃったのでこれはもう相談しようというふうになったのがきっかけですね。要は自分が今までやり尽くしてきた知識ノウハウ、こういうものを色々駆使したりますます増やしていっても成果が出て来ないと。これはもっと違うものが原因なんじゃないかな、それはなんなんだろうっていうのを、マインドとかそういうところにあるんじゃないかって仮定して、それの答えを頂けそうだったのが赤石先生だったっていう感じです。'
      },
      {
        question: '私を利用するときは、他の人とは比べましたか?',
        answer: 'そうですね。比べましたね。それは、遠藤塾にいらっしゃるような他の税理士の方々とかあとはマーケティングのコンサルティングの方々とか、あとはよくある総研系のコンサルティング会社とか、あとはフリーランスとか零細中小レベルのコンサルティング会社マーケティング会社。そういったところとは比較するみたいな感じはありましたね。'
      },
      {
        question: 'なぜ最終的に私を選んだんですか?',
        answer: '最終的にですか?やっぱりそれは自分が欲してるのはノウハウじゃなくて志とか精神とか理念とかそういった見えるノウハウとか戦略とかそういうんじゃなくて、もっと根源的なものこそ必要なんじゃないかなと思ってたところで、他の例えば先生方とか会社とか業者さんとかっていうのは、たったの何日で成果が出る７つの秘訣とは、みたいななんかそういう打ち出し方をしてるのがなんか未だに散見されるところ、赤石先生の場合は、いやもうそういうのだけじゃ駄目だよと。そもそも何の為に働くのかとか、世の中に貢献するっていう意志がないところにはどんな施策を打っても意味が無いとか、あとちょうど戦略を勉強してるところで孫子の兵法とかそういったところなんかも勉強してるときに、赤石先生もそういうことを書いてらっしゃって、そのへんの知識にも長けてらっしゃるんで、要は必要な戦略、知識ノウハウマーケティングノウハウとかも存じ上げてる上で、それはあくまでツールであって、もっと大事なのは在り方やり方志し心構え、そういったものが本質なんだっていうことを分かってらっしゃる方だと思って、そういうノウハウとマインド、マインドもただテクニック的にマインドを知ってるっていうよりは、いやそこの本音本質こそが源流なんだよということをちゃんと納得してらっしゃる方というか熟知してらっしゃるっていうところで、この方が適任だろうというふうには感じました。判断しました。'
      },
      {
        question: '私をどんなふうに活用してますか?',
        answer: 'どんなふうに活用ですか?そうですね、これはもうだから、僕の中では参謀役とか、企業で言うなら副社長とか、そういう重要な決定事項とかを客観的に見て頂きたいとかご感想を聞かせて頂きたいとか、そんな感じですね。だから、外部の頼りになる参謀って感じですね。感情に流されない、冷静な分析が出来る。かといって心とか志とか思いとかっていうものを蔑ろにせずに大切にするっていう、心技体っていうんですかね。心と技、まぁ体はちょっと何か分かりませんが。そういうものがバランスよく取れてる頼りになる方っていうイメージですね。そういうのに活用するっていうんだったらしてると思います。第三者の判断機関。自分のアイデア事業の方向性はこういうところでいいんだろうかっていうときの冷静なアドバイザー、指南役、顧問、そういったポジションでしょうかね。'
      },
      {
        question: '私の良いところ3つと悪いところ3つを教えてください',
        answer: '良い所はやっぱり色んなジャンルに知識が広い。それも結構深い。広く深い知識があるので、相談したときに返ってくる答えの深みが深いなというところがありますね。見聞が広い。あとはですね、相談の開口一番くらいに一番ネックになっていることとか、諸悪の根源をずばっと一言で言い当てるみたいなところの洞察力っていうんですかね、分析力、問題の発見能力というか、それにはすごいずば抜けた才能というか見識があるっていうような感じがありますね。あとは面倒見がいいところですね、３つ目。この前、一番最初、３月でしたよね。もし良かったらコーチングしましょうかって言ったときに、このテーマになるとだいたいすごい長くなるから４時間くらい時間押さえといて、でも結局２時間か３時間ぐらいはお話聞いて頂いて、適切なアドバイスもして頂いたんですけど、要はそういうお客さんに対しての面倒見の良さ。あとはお客さんに対しての本気度の高さとか、なんていうのかな、責任感の強さとかそういうところが３つ目の良いところかなとうふうに感じました。悪いところはですね、これはほんとにこじつけとかになるような感じなんですけど、さっきの良い所の裏返しみたいな所になるのかという気がしますね。あえて言う感じになるんですけど。相談する際はですね、これも良いところの裏返しだから僕は悪いところっていうのもちょっとはばかられるんですけど、いきなり本質的なところをずばっと突かれるんで、心構えをしてないとショックが大きいことが挙げられるかもしれないですね。例えば、ほんと今でも強烈に印象に残ってるのが、相談して、開口一番くらいの超初期のところで、尾西さんのブログを読ませて頂いたんですけど、これじゃあウンコですよみたいな表現だったんですね。それがいきなりどういう意味なんだっていうところで。要は、望ましくないお客、つまりハエがたかるのはウンコにたかりますよねと。ウンコがそういう臭いを放ってるからハエが寄せ付けられるんですよねと。尾西さんのブログは全部読んで下さったみたいなんですけど、読ませて頂いたときに尾西さんのブログから発せられてるにおいがそういう望まないお客さんを引き寄せてるっていうふうに見受けられましたよっていう。もう全くもってその通りで非常に納得度も高いですし、素晴らしい分析力、見識とアドバイスなんですけど、開口一番、特に心の準備が出来てなくてバンってそういうふうに言われると結構ショックが大きいかもしれないなというふうには思いました。あとは、無理矢理に、思いつかないんですけど、それが唯一のあえて言うなら悪いところみたいに感じますけどね。３つはないと思います。'
      },
      {
        question: '私への今後の期待要望を教えてください',
        answer: 'だいたいこういう相談って正直言うと他にも色んな先生業の方とか、プロの人とかに相談してるんですけど、正直言うと一番納得感あって一番実行効果が高いのはやっぱり赤石先生なんですね。それはなんでかなと思ったときにやっぱり先ほども申し上げた通り、知識見聞が広いのと、やっぱり税理士というお仕事、公認会計士税理士のお仕事されてて、実地で経営者の方々と実戦経験も非常に豊富だというところ、そういうところの経営の知識経験も深い上に、そうやって社長さんたちとかともたくさん接せられてるということで人間力とか精神とかそういうところもすごい鍛えられてるとか、経験が高い、そういったところが他の先生方とは一線を画してるっていう感じがするんですね。他の先生方た例えば一つのジャンル、切り口から見てあなたこういうところが駄目だよねとか、例えばですけど、SEOの業者さんだとしたらSEOがないからあなたは駄目だというけど、それそもそも供給過多なんだからそういうところでSEOあげたところで効果が無いよねっていう冷静な見方が出来ない人が結構多かったんですね。専門家しすぎる功罪なのか分からないですけど。そういうのが結構気になったんですよ。僕は結構自分で言うのもなんなんですけど、素直で行動力があるタイプだと思うので、言われたことは確実に実行するんですね、しかも結構な量。それでもやっぱり上手くいかない理由っていうのが分からずに専門家の先生をたらい回しじゃないですけどジプシーのようにさまよい続けてた時期もあったんですけど、赤石先生はそういったものを全部包括して、俯瞰、全体像、そういったところからの足りない点とか至らぬ点とかを指摘してくれるところは、これちょっと他では見られないよねって言う感じしました。あとは、僕が解決したかったことっていうのは、税理士先生公認会計士先生っていうと、ファイナンスのところ、資金繰りとかなんかそういう税金とか人件費とか経費とかそういう戦略、ファイナンスとかキャッシュフローみたいなところの専門家でそういったところの問題解決っていうイメージがあるんですけど、赤石先生に至ってはですね、僕どっちかっていうとそういうファイナンスの相談全くしたことなくて、どちらかというとマーケティングとか、一言で大ジャンルで言うとマーケティング。だけどその実、マーケティングっていうのは何が足りないのかって、ポジション、世の中に対するかけがえの無い仕事をしてる、社会のかけがえの無い仕事の役割を担ってるっていう仕事が出来てないとかポジションが取れてないとか。じゃあそのためにもなんのために働くのかっていう理念とか思いとか志とかって重要なんじゃないですかと。こういうことを言う税理士先生とか公認会計士先生とか見たこと会ったことないので、こういったところが赤石先生ならでは。つまり、なんていうんでしょうね、看板とか保有資格は公認会計士税理士っていうところがあるんですけど、その実は、もう経営全般、経営全てにおいて必要なジャンルの分野を網羅していて、適切なアドバイス、問題解決、そういうのを促せる希有な先生っていう感じだと思います。だから、そういう知恵蔵先生のこういう相談切り口教えてくれることをもっと多くの人に知ってもらいたいなっていうふうに思います。それこそ大中小企業、事業規模関わらず経営者の方々是非知恵蔵先生の価値観教えとかそういうのを知って頂きたいですし。あとはこれから世の中に出る学生さんとか社会人になる方に、どちらかといったらサラリーマンとして就業するというよりはこれから何か事業起こしますみたいな、起業家経営者気質の方々に若いうちからこういう知恵蔵先生の哲学とか、その哲学に基づいた知識を積んで頂きたいなと。そういう人がどんどん日本に増えてくれたら嬉しいなというふうに思います。'
      }
    ]
  };

  const otherTestimonials = [
    {
      name: '仲井 美和',
      company: '関西ビジネスサテライト',
      title: '代表取締役',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/127d7ef9c2e9720f90b5b1713d70cfca.png',
      link: '/testimonials/interview/nakai-miwa'
    },
    {
      name: '井上様',
      company: '株式会社ブラフ',
      title: '代表',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/35b8762a66e1873ce7fb0f80abf5f547.png',
      link: '/testimonials/interview/inoue'
    },
    {
      name: '岡田 学',
      company: '株式会社イビリス',
      title: '代表取締役',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/2f9f9198753682b69ba4c9262eb11081.png',
      link: '/testimonials/interview/okada-manabu'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <section className="pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            {/* 戻るボタン */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              className="mb-8"
            >
              <a
                href="/testimonials"
                className="inline-flex items-center gap-2 text-gray-600 hover:text-red transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
                <span className="text-sm font-medium">お客様の声一覧に戻る</span>
              </a>
            </motion.div>

            {/* ヘッダー */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-16"
            >
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                お客様インタビュー
              </h1>
              <p className="text-xl text-gray-600">
                {testimonial.company} {testimonial.name}
              </p>
            </motion.div>

            {/* コンテンツ */}
            <div className="grid lg:grid-cols-5 gap-12">
              {/* 左側:プロフィール */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
                className="lg:col-span-2"
              >
                <div className="sticky top-8">
                  <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-8">
                    <div className="w-full" style={{ aspectRatio: '1920/1080' }}>
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-3xl p-8 border border-red/10">
                    <h3 className="text-3xl font-bold text-red mb-4">
                      {testimonial.company}
                    </h3>
                    <p className="text-gray-600 mb-2">{testimonial.title}</p>
                    <p className="text-xl font-medium text-gray-900">
                      {testimonial.name}
                    </p>
                  </div>
                </div>
              </motion.div>

              {/* 右側:インタビュー内容 */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
                className="lg:col-span-3"
              >
                <div className="space-y-10">
                  {testimonial.sections.map((section, index) => (
                    <motion.div
                      key={index}
                      id={index === 0 ? "interview-content" : undefined}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.4 + index * 0.1 }}
                      className="bg-white rounded-2xl p-8 border border-gray-100 hover:border-red/20 hover:shadow-lg transition-all"
                    >
                      <div className="flex items-start gap-4 mb-6">
                        <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                          <span className="text-red font-bold text-sm">Q{index + 1}</span>
                        </div>
                        <h4 className="text-xl font-bold text-gray-900 leading-relaxed pt-1">
                          {section.question}
                        </h4>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-10 h-10 bg-red-light/10 rounded-full flex items-center justify-center flex-shrink-0">
                          <span className="text-red-light font-bold text-sm">A</span>
                        </div>
                        <div className="text-gray-700 leading-relaxed pt-1">
                          {section.answer.split('。').map((sentence, i) => (
                            sentence.trim() && (
                              <p key={i} className="mb-3">
                                {sentence.trim()}。
                              </p>
                            )
                          ))}
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>

                {/* CTA */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 }}
                  className="mt-16 bg-gradient-to-br from-red-dark to-red rounded-3xl p-12 text-center"
                >
                  <h3 className="text-3xl font-bold text-white mb-4">
                    あなたも「勝つ経営」を実現しませんか？
                  </h3>
                  <p className="text-white/90 mb-8 text-lg">
                    無料相談で、あなたのビジネスの可能性を一緒に探りましょう
                  </p>
                  <a
                    href="/#contact"
                    className="inline-block bg-white text-red px-12 py-4 rounded-full text-[15px] font-medium hover:bg-gray-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
                  >
                    無料相談を予約する
                  </a>
                </motion.div>

                {/* Other Testimonials Section */}
                <section className="py-20 bg-gradient-to-br from-red/5 via-white to-red-light/5">
                  <div className="max-w-7xl mx-auto px-6">
                    <motion.h2
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12"
                    >
                      他のお客様の声
                    </motion.h2>
                    <div className="grid md:grid-cols-3 gap-8">
                      {otherTestimonials.map((testimonial, index) => (
                        <motion.a
                          key={testimonial.id}
                          href={testimonial.link}
                          initial={{ opacity: 0, y: 30 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ delay: index * 0.1 }}
                          className="group relative rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all cursor-pointer"
                        >
                          <div className="relative" style={{ aspectRatio: '1920/1080' }}>
                            <img
                              src={testimonial.image}
                              alt={testimonial.name}
                              className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center pb-12">
                              <div className="text-center">
                                <div className="inline-flex items-center gap-2 bg-white text-red px-8 py-3 rounded-full font-medium">
                                  <span>詳しく見る</span>
                                  <i className="ri-arrow-right-line"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="p-6 bg-gradient-to-br from-red/5 to-red-light/5 border-t border-red/10">
                            <h3 className="text-xl font-bold text-red mb-2">
                              {testimonial.company}
                            </h3>
                            <p className="text-gray-600 text-sm mb-1">{testimonial.title}</p>
                            <p className="text-lg font-medium text-gray-900">
                              {testimonial.name}
                            </p>
                          </div>
                        </motion.a>
                      ))}
                    </div>
                  </div>
                </section>
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default OnishiPage;
